import DefaultMapper from '../../dataProvider/DefaultMapper';

class UserAddressMapper extends DefaultMapper {

	mapResource({ resource, params }) {
		return `user/users/${params.id}/addresses`;
	}

}

export default UserAddressMapper;
